{
	"recoveryPassword": "Recuperação de senha"
}
